import moment from "moment";
import * as S from "sanctuary";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone"; // dependent on utc plugin; order matters
import advanced from "dayjs/plugin/advancedFormat";

// These are necessary to display the abbreviated Timezone in the table header
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

export const timezones = [
  {
    value: "America/Los_Angeles",
    text: "Pacific",
  },
  {
    value: "America/Denver",
    text: "Mountain",
  },
  {
    value: "America/Chicago",
    text: "Central",
  },
  {
    value: "America/New_York",
    text: "Eastern",
  },
];

export const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const toFormattedDate = (date, userTimezone) =>
  S.fromMaybe("")(
    S.map((date) =>
      dayjs(date)
        .tz(S.fromMaybe(DEFAULT_TIMEZONE)(userTimezone))
        .format("MM/DD/YY[ - ]hh:mm:ss a")
    )(date)
  );

export const toFormattedDateNoTime = (date) =>
  S.fromMaybe("")(S.map((date) => dayjs(date).format("MM/DD/YY"))(date));

export const toFormattedDateNoTimeLocalized = (date, userTimezone) =>
  S.fromMaybe("")(
    S.map((date) =>
      dayjs(date).tz(S.fromMaybe(DEFAULT_TIMEZONE)(userTimezone)).format("MM/DD/YY")
    )(date)
  );

export const getMomentDate = () => moment();
